export const info = [
  {
    id: 1,
    name: '1.21.23',
    phone: 'Investment in associate',
    email: '33404',
    country: '3490944',
    alphanumeric: 'NXO38WBH6OY',
  },
  {
    id: 2,
    name: '1.21.23',
    phone: 'Investment in associate',
    email: '33404',
    country: '3490944',
    alphanumeric: 'NXO38WBH6OY',
  },
];
